import { reducer } from './modules';

export { default as deputyActions } from './modules';
export { default as deputySaga } from './sagas';
export { default as deputySelectors } from './selectors';
export { default as deputyOperations } from './operations';

export default reducer;
